import { sha512 } from 'js-sha512';
import { APP_URL, getRnd } from 'lib/utils/urlUtils';

const recoverURL = `${APP_URL}/auth/recover`;

export const verifyRecoverToken = async (token) => {
  const url = new URL(`${recoverURL}/verifyToken`);
  url.searchParams.set('token', token);
  url.searchParams.set('rnd', getRnd());
  const response = await fetch(url, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    method: 'GET',
    credentials: 'same-origin',
  });
  const data = await response.json();
  if (!response.ok || typeof data !== 'boolean') {
    throw new Error('Invalid verifyToken response');
  }
  return data;
};

export const changePassword = async (password, confirmPassword, token) => {
  const url = new URL(`${recoverURL}/changePassword`);
  url.searchParams.set('rnd', getRnd());
  try {
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        password: sha512(password),
        confirmPassword: sha512(confirmPassword),
        token: token,
      }),
      method: 'POST',
      credentials: 'same-origin',
    });
    const data = await response.json();
    return response.ok && data === true;
  } catch (e) {
    return false;
  }
};
